import { defineComponent as _defineComponent } from 'vue'
interface Props {
	height?: string | number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RmpBottomSpace',
  props: {
    height: { default: 76 }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})